import React, { useEffect, useState } from "react";
import "./HeartBurstAnimation.css";

interface HeartBurstAnimationProps {
  isVisible: boolean;
  onAnimationEnd: () => void;
}

const HeartBurstAnimation: React.FC<HeartBurstAnimationProps> = ({
  isVisible,
  onAnimationEnd,
}) => {
  const [showHeart, setShowHeart] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShowHeart(true);

      // 애니메이션 시간 후 정리
      const timer = setTimeout(() => {
        onAnimationEnd();
        setShowHeart(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onAnimationEnd]);

  if (!isVisible || !showHeart) {
    return null;
  }

  return (
    <div className="heart-burst-container">
      <div className="heart-smoke-item">❤️</div>
    </div>
  );
};

export default HeartBurstAnimation;
